import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaHome, FaUser, FaGraduationCap, FaProjectDiagram, FaEnvelope, FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const menuPrincipal = [
        { label: 'Accueil', path: '/', icon: <FaHome size={16} /> },
        { label: 'À propos', path: '/apropos', icon: <FaUser size={16} /> },
        { label: 'Parcours', path: '/parcours', icon: <FaGraduationCap size={16} /> },
        { label: 'Projets', path: '/projets/intro', icon: <FaProjectDiagram size={16} /> },
        { label: 'Contact', path: '/contact', icon: <FaEnvelope size={16} /> },
    ];

    const handleNavigation = (path) => {
        navigate(path);
        setIsOpen(false);
    };

    return (
        <>
            <style>{`
                .header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    padding: 15px 40px;
                    background: #1f3a43;
                    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
                    position: fixed;
                    top: 0;
                    left: 0;
                    z-index: 1000;
                    box-sizing: border-box;
                }

                .logo {
                    font-weight: 700;
                    font-size: 1.3rem;
                    color: #ffffff;
                    cursor: pointer;
                    letter-spacing: 1px;
                }

                .logo span {
                    color: #ffd700;
                }

                .mobile-toggle {
                    display: none;
                    background: transparent;
                    border: none;
                    color: #ffffff;
                    cursor: pointer;
                    padding: 5px;
                }

                .nav-menu {
                    display: flex;
                    gap: 20px;
                    align-items: center;
                }

                .nav-item {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    background: transparent;
                    border: none;
                    cursor: pointer;
                    color: #ffffff;
                    font-size: 1rem;
                    font-weight: 500;
                    padding: 8px 12px;
                    border-radius: 8px;
                    transition: all 0.3s ease;
                }

                .nav-item:hover,
                .nav-item.active {
                    color: #ffd700;
                }

                .nav-item.active {
                    font-weight: 600;
                }

                /* Mobile & Tablette (<= 768px) */
                @media (max-width: 768px) {
                    .header {
                        padding: 15px 20px;
                    }

                    .mobile-toggle {
                        display: block;
                    }

                    .nav-menu {
                        position: absolute;
                        top: 100%;
                        left: 0;
                        width: 100%;
                        flex-direction: column;
                        background: #1f3a43;
                        gap: 0;
                        max-height: 0;
                        overflow: hidden;
                        transition: max-height 0.3s ease-in-out;
                        box-shadow: 0 8px 10px rgba(0, 0, 0, 0.3);
                    }

                    .nav-menu.active {
                        max-height: 350px;
                        padding: 10px 0;
                    }

                    .nav-item {
                        width: 100%;
                        padding: 12px 20px;
                        justify-content: flex-start;
                        border-radius: 0;
                    }
                }
            `}</style>

            <header className="header">
                <div className="logo" onClick={() => handleNavigation('/')}>
                    R<span>m</span>
                </div>

                <button 
                    className="mobile-toggle" 
                    onClick={() => setIsOpen(!isOpen)} 
                    aria-label="Toggle Navigation"
                >
                    {isOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
                </button>

                <nav className={`nav-menu ${isOpen ? 'active' : ''}`}>
                    {menuPrincipal.map((item, idx) => {
                        const isActive = location.pathname === item.path;

                        return (
                            <button
                                key={idx}
                                onClick={() => handleNavigation(item.path)}
                                className={`nav-item ${isActive ? 'active' : ''}`}
                            >
                                {item.icon}
                                <span>{item.label}</span>
                            </button>
                        );
                    })}
                </nav>
            </header>
        </>
    );
};

export default Header;